// extracted by mini-css-extract-plugin
export default {"AffordableHealthWrapper":"FEFhZtkT","AffordableHealthContent":"B3qWG1mC","AffordableHealthTitle":"CTtelBk1","AffordableHealthBody":"YfGhVr68"};